import {
  formatToReal,
  getColorScore,
  getImageURLScore,
} from "../../../utils/utils";
import TitleStripe from "../TitleStripe";

const companySize = {
  1: "MEI",
  2: "ME",
  3: "EPP",
  4: "Demais Portes",
};

const riskIndicators = {
  R0: "Empresa apresenta Score de baixo risco de inadimplência",
  R1: "Possui poucas ou nenhuma informação no Cadastro Positivo",
  R2: "A empresa foi aberta recentemente",
  R3: "Possui quadro societário com baixo número de sócios ou acionistas",
  R4: "Possui atrasos e/ou pendencias financeiras ativas",
  R5: "Possui atrasos de parcelas/faturas em contratos recentes",
  R6: "Possui histórico de atraso nos últimos 3 meses",
  R7: "Possui histórico de atrasos nos últimos 6 meses",
  R8: "Possui atrasos e/ou pendencias financeiras ativas",
  R9: "Possui atrasos e/ou pendencias financeiras ativas",
  R10: "Possui alta quantidade de contratações realizadas nos últimos 12 meses",
  R11: "Possui uma media alta de dias em atraso nas parcelas/faturas dos últimos 6 meses",
  R12: "Possui utilização de alto valor de crédito do tipo emergencial nos últimos 3 meses",
  R13: "Possui utilização de crédito emergencial recentemente",
  R14: "Possui contratação recente de produtos de crédito",
  R15: "Possui contratação recente de produtos de crédito",
  R16: "Possui contratos com grande quantidade de parcelas",
  R17: "Possui atrasos recentes",
  R18: "Possui parcelas/faturas em atraso nos últimos 12 meses",
  R19: "Possui contratos com alto valor para quitação",
  R20: "Não possui histórico de relacionamento com grandes Instituições financeiras",
  R21: "Possui grande quantidade de credores e/ou contratos com dividas em aberto",
  R22: "Possui atrasos vigentes",
  R23: "Possui menor tendência de recuperação de dívidas em atraso",
  R24: "Possui grande quantidade de credores e/ou contratos com dividas em aberto nos últimos 6 meses",
  R25: "Possui atrasos mais longos",
  R26: "Possui maior comprometimento da renda com parcelas em aberto",
  R27: "Possui baixa frequência de pagamentos realizados sem atraso",
  R28: "Possui pouco volume de pagamentos em dia",
  R29: "Possui poucas contratações de produtos de crédito recentemente",
  C3: "A relação entre os ativos e os passivos atuais é muito baixa",
  C0: "A relação entre dívidas e o valor patrimonial líquido é muito alta",
  H1: "Tempo que a empresa está sob a gerência atual",
  H3: "Ausência de informações financeiras sobre a empresa",
  H4: "Ausência de informações sobre o valor patrimonial líquido",
  H5: "O valor patrimonial líquido é muito baixo",
  H6: "Informações demográficas sobre a empresa",
  H7: "O valor patrimonial líquido é muito baixo",
  H8: "Tempo que está na empresa",
  X1: "Idade dos principais requerentes",
  X2: "Estrutura da empresa",
  X5: "Ausência de informações sobre a empresa",
  X9: "Ausência de informações sobre a empresariais",
  Y0: "Lucro muito baixo",
  Y2: "A relação entre lucros e vendas é muito baixa",
  Y3: "Vendas muito baixas",
  Y4: "Vendas muito baixas",
  Z1: "Relação entre vendas e ativos é muito baixa",
  Z2: "Muitas consultas empresariais recentes",
  Z3: "Atraso nas contas empresariais",
  Z4: "O valor devido nas contas empresariais é muito alto em relação ao das outras empresas",
  Z5: "O saldo em atraso nas contas empresariais é muito alto",
  Z6: "Atrasos graves ou informações depreciativas nas contas empresariais",
};

const ScoreBoletoPJ = ({ data }) => {
  return (
    <>
      <TitleStripe>Score com boleto</TitleStripe>
      <div className="grid grid-cols-2 gap-10 items-center">
        <div className="pt-2 px-14 pb-0 max-w-md mx-auto">
          <img src={getImageURLScore(data?.Score)} />
          <div
            className="font-semibold text-lg rounded p-2 w-fit text-white shadow-md mx-auto"
            style={{
              background: `${getColorScore(data?.Score)}`,
            }}
          >
            Score {Math.floor(data?.Score)}
          </div>
        </div>

        <div className="mt-2 border border-gray-300 p-2 flex flex-col">
          <div>
            Porte da empresa:{" "}
            <span className="underline">{companySize[data?.CompanyPort]}</span>
          </div>
          <div className="mb-3">
            Probabilidade de inadimplência: <b>{data?.ProbabilityDefault}%</b>
          </div>
          <div className="underline font-semibold mb-1">Motivos do Score</div>
          <div>
            {data?.ReasonCode1 && (
              <div>
                <div className="">- {riskIndicators[data?.ReasonCode1]}</div>
              </div>
            )}
            {data?.ReasonCode2 && (
              <div>
                <div className="">- {riskIndicators[data?.ReasonCode2]}</div>
              </div>
            )}
            {data?.ReasonCode3 && (
              <div>
                <div className="">- {riskIndicators[data?.ReasonCode3]}</div>
              </div>
            )}
            {data?.ReasonCode4 && (
              <div>
                <div className="">- {riskIndicators[data?.ReasonCode4]}</div>
              </div>
            )}
          </div>
        </div>
      </div>
    </>
  );
};

export default ScoreBoletoPJ;
